import { paths } from "@/App";
import { setLatestTeamExternalId } from "@/lib/local-storage";
import { useTeamQuery } from "@/lib/queries/team-queries";
import { useSelfQuery } from "@/lib/queries/user-queries";
import { useEffect, useMemo } from "react";
import { Outlet, Navigate, useParams } from "react-router";

export default function TeamGuard() {
  const { data: self, isSuccess } = useSelfQuery();
  const { teamExternalId } = useParams();

  const { isSuccess: isTeamSuccess } = useTeamQuery(teamExternalId!);

  const teamExternalIds = useMemo(() => {
    return (
      self?.teamMemberships.map((membership) => membership.teamExternalId) || []
    );
  }, [self]);

  useEffect(() => {
    if (teamExternalId && teamExternalIds.includes(teamExternalId)) {
      setLatestTeamExternalId(teamExternalId);
    }
  }, [teamExternalIds, teamExternalId]);

  if (!isSuccess || !self || !teamExternalId) {
    return null;
  }

  if (!teamExternalIds.includes(teamExternalId)) {
    return <Navigate to={paths.root()} />;
  }

  // Ensures that team is loaded before rendering the outlet to avoid UI flickering
  if (!isTeamSuccess) {
    return null;
  }

  return <Outlet />;
}
